import React from 'react';
import { METRIC_TYPES, MetricType } from '../config/metric-config';
import './MetricValue.scss';

interface MetricValueProps {
  value: number;
  type: MetricType;
  className?: string;
  showPercentage?: boolean;
  decimals?: number;
  displayComponent?: React.ReactNode;  // Optional custom display component
}

/**
 * Component that displays a metric value with a progress bar background
 * showing the value relative to a configured maximum.
 */
const MetricValue: React.FC<MetricValueProps> = ({ 
  value, 
  type, 
  className = '',
  showPercentage = false,
  displayComponent
}) => {
  const config = METRIC_TYPES[type];
  
  if (!config) {
    console.warn(`MetricValue: Unknown metric type "${type}"`);
    return <span>{value.toLocaleString()}</span>;
  }

  // Calculate percentage (capped at 100%)
  const percentage = Math.min((value / config.max) * 100, 100);

  return (
    <div className={`metric-value-container ${className}`}>
      {/* Progress bar background */}
      <div
        className="metric-value-progress"
        style={{
          width: `${percentage}%`
        }}
      />
      
      {/* Value text */}
      <div className="metric-value-text">
        {/* Use displayComponent if provided, otherwise use formatted value */}
        {displayComponent}
        {showPercentage && (
          <span className="metric-value-percentage">
            ({percentage.toFixed(1)}%)
          </span>
        )}
      </div>
    </div>
  );
};

export default MetricValue;